(function(angular){
	'use strict';
	
	angular.module('hypotheticalPerformanceModule', [
		'animateOnChangeModule',
		'coreModule',
		'futureEarningsChartModule',
		'hypotheticalPerformanceChartModule',
	]);

})(window.angular);